import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export const SOP_DATE_PATTERN = '^\\d{4}-\\d{2}$';

export function sopDateValidators(required = false): ValidatorFn[] {
    return [
        ...(required ? [Validators.required] : []),
        Validators.pattern(SOP_DATE_PATTERN),
        sopDateValidator,
    ];
}

export function sopDateValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    const match = value.match(/^\d{4}-(\d{2})$/);
    if (!match) return null;

    const month = parseInt(match[1], 10);
    if (month < 1 || month > 12) {
        return { invalidMonth: true };
    }

    return null;
}
